import React from 'react';
import HelpApiLayout from '../../../../components/layout/HelpApiLayout';
import HelpSidebar from '../../../../components/layout/HelpSidebar';
import AccordionCard from '../../components/AccordionCard';
import LastUpdated from '../../../../components/layout/docs/LastUpdated';
import '../../HelpCenter.css';
import './FAQ.css';

/**
 * FAQ Category Page
 * Long cards with expandable answers
 */
const FAQ = () => {
  const faqs = [
    {
      question: 'What is WeSplit used for?',
      answer: 'WeSplit helps you split expenses, share costs, and send payments with friends in a simple and social way — using crypto for instant settlement. You can create groups, track expenses, and manage shared wallets all in one place.'
    },
    {
      question: 'Do my friends need to use WeSplit too?',
      answer: 'Yes — everyone joins the same group to track, approve, and split expenses together. This ensures transparency and makes it easy to manage shared expenses with your friends, family, or team members.'
    },
    {
      question: 'Is WeSplit safe to use?',
      answer: 'Yes. WeSplit uses multi-signature wallets so no one can move group funds alone. All transactions require approval from group members, ensuring that your funds are secure and protected at all times.'
    },
    {
      question: 'Is WeSplit free?',
      answer: 'Yes — you only pay standard blockchain transaction fees. There are no hidden costs, subscription fees, or monthly charges. You only pay for the actual transactions you make on the Solana blockchain.'
    },
    {
      question: 'Do I need crypto experience to use it?',
      answer: 'Not at all — WeSplit works just like a normal payment app. Crypto runs quietly in the background. You don\'t need to understand blockchain technology or cryptocurrency to use WeSplit effectively.'
    },
    {
      question: 'What can I use WeSplit for?',
      answer: 'Trips, rent, events, shared purchases, or everyday expenses with friends. Whether you\'re splitting a dinner bill, managing rent with roommates, or organizing a group trip, WeSplit makes it easy.'
    },
    {
      question: 'Which blockchain does WeSplit use?',
      answer: 'WeSplit is built on Solana for fast, low-cost payments. Solana\'s high throughput and low transaction fees make it ideal for everyday payments and expense splitting.'
    },
    {
      question: 'Can I use WeSplit with a large group or community?',
      answer: 'Yes — from small friend groups to teams and DAOs, WeSplit scales with your needs. You can create groups of any size and manage expenses efficiently regardless of the number of members.'
    }
  ];

  return (
    <HelpApiLayout type="help" sidebar={<HelpSidebar />}>
      <div className="help-center">
        <div className="help-center-container">
          <header className="lp-section-header">
            <h1 className="lp-section-title">FAQ</h1>
            <p className="lp-section-subtitle">
              Quick answers to the most common questions.
            </p>
          </header>

          <section className="help-center-categories">
            <div className="faq-list">
              {faqs.map((faq, index) => (
                <AccordionCard
                  key={index}
                  question={faq.question}
                  answer={faq.answer}
                />
              ))}
            </div>
          </section>

          <LastUpdated />
        </div>
      </div>
    </HelpApiLayout>
  );
};

export default FAQ;
